import React, { useState } from "react";
import "./reciptIndexInput.scss";
import AllServices from "../../Services/AllServices";
import { useNavigate, useLocation } from "react-router-dom";
import CustomLoaderBoxy from "../../components/CustomLoader/CustomLoaderBoxy";
import { toast } from "react-toastify";
import EditNoteIcon from "@mui/icons-material/EditNote";
import dayjs from "dayjs";

const ReciptIndexInput = ({ refNumber, registerdDate, onClose }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({
    reciptId: "",
    registerdDate: registerdDate,
  });

  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.reciptId.trim()) {
      setError("Receipt Reference Number cannot be empty");
      return;
    }
    setError("");

    const sqlDate = registerdDate ? new Date(registerdDate) : null;

    console.log(typeof sqlDate);

    setLoading(true);
    let dataObj = {
      ReciptID: form.reciptId,
      RegisterDayToWP: sqlDate,
    };
    try {
      const response = await AllServices.saveReciptId(refNumber, dataObj);

      if (response.data.succuss) {
        toast.success(response.data.message);
        onClose();
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {loading && (
        <div className="loader-overlay">
          <CustomLoaderBoxy />
        </div>
      )}

      <div className="login-box">
        <div className="login-header">Add Recipt Reference Number</div>

        <div className="login-body">
          <div className="input-group">
            <EditNoteIcon className="input-icon" />
            <input
              type="text"
              placeholder="Recipt Reference Number"
              onChange={handleChange}
              name="reciptId"
            />
            {error && <div className="input-error">{error}</div>}
          </div>

          <div className="button-group">
            <button className="btn btn-blue" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReciptIndexInput;
